import React, { useState } from "react"
import Select from "react-select";
import { connect } from "react-redux"
import {searchDispatchAction} from "../../../state/product/dispatchActions";
import {formatCompactNumber} from "../../../helpers/utilsHelper";
import FooterButtons from "./shared/FooterButtons";
import {PAGE_SIZE_FIELD_TYPE_OPTIONS} from "../../../helpers/searchResultsHelper";
import {SearchResultsType} from "../../../types/product";
import {FIRST_SEARCH_PAGE_NUMBER} from "../../../helpers/searchHelper";
import translations from "../../../translations";

interface PropsType {
  searchResults: SearchResultsType,
  formData: any,
  searchFormValues: any,
  searchDispatchActionHandler: any,
  language: string,
  searchByProducts: boolean,
  searchProductIds: string[],
  currentPage: number
}

const FooterSearchResultsSidebar = (props: PropsType) => {
  const {
    searchResults,
    formData,
    searchDispatchActionHandler,
    language,
    searchByProducts,
    searchProductIds,
    currentPage
  } = props;
  const { links } = searchResults;

  // prendo token in base al contenuto di links
  let prevToken = null;
  let nextToken = null;
  links.forEach((link) => {
    if (link.body && link.body.token) {
      if (link.rel === "next") {
        nextToken = link.body.token;
      } else if (link.rel === "previous") {
        prevToken = link.body.token;
      }
    }
  });

  const options = PAGE_SIZE_FIELD_TYPE_OPTIONS.map((option) => {
    return {
      label: translations(option.label, language),
      value: option.value
    }
  });

  return (
    <div className="row mx-0 sidebar-secondpart-footer px-0 py-4">
      <div className="col-6 nav-paragraph-container pr-0">
        <button
          type="button"
          className="page-nav-btn remove-btn-defaults pl-0"
          disabled={!prevToken}
          onClick={() => searchDispatchActionHandler({...formData, token: prevToken}, false, language, searchByProducts, searchProductIds)}
        >
          <svg><use xlinkHref="#left_arrow-icon" fill="#9A9BA6" /></svg>
        </button>
        <p className="nav-paragraph m-0">
          {`${translations("page", language)}  ${currentPage} ${translations("of", language)} ${formatCompactNumber(searchResults.totalPages)}`}
          <br />
          { searchResults.totalItems ? `${formatCompactNumber(searchResults.totalItems)} ${translations("resultsResults", language)}` : "" }
        </p>
        <button
          type="button"
          className="page-nav-btn remove-btn-defaults pr-0"
          disabled={!nextToken}
          onClick={() => searchDispatchActionHandler({...formData, token: nextToken}, false, language, searchByProducts, searchProductIds)}
        >
          <svg><use xlinkHref="#right_arrow-icon" fill="#9A9BA6" /></svg>
        </button>

        <Select
          name="pageSizeFieldType"
          className="page-size-field-type-selection"
          options={options}
          styles={{
            menu: (styles) => {
              return {
                ...styles,
                top: "auto",
                bottom: "100%"
              };
            }
          }}
          value={options.find((option) => option.value === formData.pageSize)}
          onChange={(option) => {
            if (option.value !== formData.pageSize) {
              searchDispatchActionHandler({...formData, token: null, pageSize: option.value}, false, language, searchByProducts, searchProductIds);
            }
          }}
        />
      </div>
      <FooterButtons
        containerClassName="col-6"
        formData={formData}
        hideBaselineFilter
      />
    </div>
  )
};

const mapStateToProps = (state) => ({
  currentPage: state.application.currentPage,
  formData: state.application.formData,
  language: state.application.appParameters.language,
  searchByProducts: state.geoMap.searchByProducts,
  searchProductIds: state.geoMap.searchProductIds,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  searchDispatchActionHandler: (formData, isNewSearch = false, language, searchByProducts, searchProductIds) => dispatch(searchDispatchAction(formData, isNewSearch, ownProps.isInterferometricStackSearch, language, searchByProducts, searchProductIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FooterSearchResultsSidebar);
